import React, { useCallback, useEffect, useState } from "react";
import { useHistory, Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Layout, Menu } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { Text } from "@iiht/components";
import { roleName, rootSubmenuKeys } from "../../../constants/componentConstants";
import { ROUTES } from "../../../constants/routesConstants";
import { localStorageHelper } from "../../../utils";
import { getUserRole } from "../../../utils/genericUtils";
import { setSideBarCollapse } from "../../../store/actions";
import "./sidebarStyle.scss";

const { SubMenu } = Menu;
const { Sider } = Layout;

const SidebarView = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const { isDarkTheme, sidebarCollapsed } = useSelector(({ common }) => common);
  const [submenuKeyPathMap, setSubmenuKeyPathMap] = useState({});
  const [openSubMenus, setOpenSubMenus] = useState([]);
  const [pathName, setPathName] = useState("");
  const history = useHistory();
  const roleList = getUserRole();
  const is_portal_login = JSON.parse(localStorageHelper.get("is_portal_login"));
  useEffect(() => {
    setSubmenuKeyPathMap(() =>
      sideNavMenu?.reduce((allMenus, currMenu) => {
        if (currMenu?.menuType === "subMenu") currMenu?.subMenu?.forEach((item) => (allMenus[item?.path] = currMenu?.key));
        return allMenus;
      }, [])
    );
  }, []);

  useEffect(() => {
    submenuKeyPathMap &&
      location?.pathname &&
      setOpenSubMenus((prevOpenMenus) => [...prevOpenMenus, submenuKeyPathMap?.[location?.pathname]]);
  }, [location?.pathname, submenuKeyPathMap]);

  const toggleCollapsed = () => {
    dispatch(setSideBarCollapse(!sidebarCollapsed));
  };
  const handleOnClick = useCallback(
    (path) => {
      if (path) {
        setPathName(path);
        history.push(path);
      }
    },
    [history]
  );

  const sideNavMenu = useSelector((state) => state.rbacManagement?.resourceList);
  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openSubMenus?.indexOf(key) === -1);

    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenSubMenus(keys);
    } else {
      setOpenSubMenus(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  const settingPathHandler = (path) => {
    setPathName(path);
  };
  const isMentor = JSON.parse(localStorageHelper.get("is_mentor") || "false");
  return (roleList === roleName?.tenantUser && !is_portal_login) || isMentor ? null : (
    <Sider
      width={sidebarCollapsed ? "3.125rem" : "11.875rem"}
      className="site-layout-background sidebar-layout-shadow"
      collapsed={sidebarCollapsed}
    >
      <Menu
        className="menu-adjust border-bottom qa-menu sider-items"
        mode="inline"
        inlineCollapsed={sidebarCollapsed}
        selectedKeys={[location?.pathname]}
        openKeys={openSubMenus}
        onOpenChange={onOpenChange}
      >
        {sideNavMenu.map((menu) => (
          <>
            {menu?.menuType !== "subMenu" ? (
              <Menu.Item
                style={{ display: "flex", alignItems: "center", height: "2.5rem", flexDirection: "row" }}
                className={`border-bottom ${menu?.className} qa-${menu?.key}-menu sider-items`}
                onClick={
                  menu?.path
                    ? () => handleOnClick(menu.path)
                    : sidebarCollapsed === false
                      ? () => {
                        toggleCollapsed();
                        menu.icon = <MenuUnfoldOutlined className="iiht-sidebar-icons" />;
                      }
                      : sidebarCollapsed === true
                        ? () => {
                          toggleCollapsed();
                          menu.icon = <MenuFoldOutlined className="iiht-sidebar-icons" />;
                        }
                        : null
                }
                key={menu?.path}
                icon={menu?.icon}
              >
                {(menu?.path && (
                  <Link className="menu-link" to={menu?.path}>
                    <Text className="label-regular menu-text">{t(menu?.title)}</Text>
                  </Link>
                )) ||
                  null}
              </Menu.Item>
            ) : (
              <SubMenu
                className={`border-bottom ${menu?.className} qa-${menu?.key}-submenu sider-items`}
                key={menu.key}
                icon={menu.icon}
                title={<Text className="label-regular">{t(menu.title)}</Text>}
                popupClassName={isDarkTheme ? "iiht-ant-submenu-popup-dark" : "iiht-ant-submenu-popup-light"}
              >
                {menu.subMenu.map((data) => (
                  <Menu.Item
                    key={data?.path}
                    className={`vertical-line border-less border-top submenu-border-left qa-${data?.key}-item sider-items-sub`}
                    style={{ display: "flex", alignItems: "start", height: "2.5rem", flexDirection: "column" }}
                  >
                    <Link to={data.path ? data.path : ROUTES.DASHBOARD} onClick={() => settingPathHandler(data?.path)}>
                      <Text className="label-regular">{t(data.title)} </Text>
                    </Link>
                  </Menu.Item>
                ))}
              </SubMenu>
            )}
          </>
        ))}
      </Menu>
    </Sider>
  );
};

export default SidebarView;
